export enum EduCalendarFilterType {

    Currency = "currency",
    Impact = "impact"
}
